export default [
	{
		countryName: 'Afghanistan',
		countryCode: 'AF',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Åland Islands',
		countryCode: 'AX',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Albania',
		countryCode: 'AL',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Algeria',
		countryCode: 'DZ',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'American Samoa',
		countryCode: 'AS',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Andorra',
		countryCode: 'AD',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Angola',
		countryCode: 'AO',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Anguilla',
		countryCode: 'AI',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Antarctica',
		countryCode: 'AQ',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Antigua and Barbuda',
		countryCode: 'AG',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Argentina',
		countryCode: 'AR',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Armenia',
		countryCode: 'AM',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Aruba',
		countryCode: 'AW',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Australia',
		countryCode: 'AU',
		tax: {
			taxIds: [
				{
					type: 'au_abn',
					name: 'Australian Business Number (AU ABN)',
					example: '12345678912',
				},
				{
					type: 'au_arn',
					name: 'Australian Taxation Office Reference Number',
					example: '123456789123',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Austria',
		countryCode: 'AT',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'AT012345678',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Azerbaijan',
		countryCode: 'AZ',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Bahamas',
		countryCode: 'BS',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Bahrain',
		countryCode: 'BH',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Bangladesh',
		countryCode: 'BD',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Barbados',
		countryCode: 'BB',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Belarus',
		countryCode: 'BY',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Belgium',
		countryCode: 'BE',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'BE0123456789',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Belize',
		countryCode: 'BZ',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Benin',
		countryCode: 'BJ',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Bermuda',
		countryCode: 'BM',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Bhutan',
		countryCode: 'BT',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Bolivia (Plurinational State of)',
		countryCode: 'BO',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Bonaire, Sint Eustatius and Saba',
		countryCode: 'BQ',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Bosnia and Herzegovina',
		countryCode: 'BA',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Botswana',
		countryCode: 'BW',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Bouvet Island',
		countryCode: 'BV',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Brazil',
		countryCode: 'BR',
		tax: {
			taxIds: [
				{
					type: 'br_cnpj',
					name: 'Brazilian CNPJ number',
					example: '01.234.456/5432-10',
				},
				{
					type: 'br_cpf',
					name: 'Brazilian CPF number',
					example: '123.456.789-87',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'British Indian Ocean Territory',
		countryCode: 'IO',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Brunei Darussalam',
		countryCode: 'BN',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Bulgaria',
		countryCode: 'BG',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'BG0123456789',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Burkina Faso',
		countryCode: 'BF',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Burundi',
		countryCode: 'BI',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Cabo Verde',
		countryCode: 'CV',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Cambodia',
		countryCode: 'KH',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Cameroon',
		countryCode: 'CM',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Canada',
		countryCode: 'CA',
		tax: {
			taxIds: [
				{
					type: 'ca_bn',
					name: 'Canadian BN',
					example: '123456789',
				},
				{
					type: 'ca_gst_hst',
					name: 'Canadian GST/HST number',
					example: '123456789RT0002',
				},
				{
					type: 'ca_pst_bc',
					name: 'Canadian PST number (British Columbia)',
					example: 'PST-1234-5678',
				},
				{
					type: 'ca_pst_mb',
					name: 'Canadian PST number (Manitoba)',
					example: '123456-7',
				},
				{
					type: 'ca_pst_sk',
					name: 'Canadian PST number (Saskatchewan)',
					example: '1234567',
				},
				{
					type: 'ca_qst',
					name: 'Canadian QST number (Québec)',
					example: '1234567890TQ1234',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Cayman Islands',
		countryCode: 'KY',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Central African Republic',
		countryCode: 'CF',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Chad',
		countryCode: 'TD',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Chile',
		countryCode: 'CL',
		tax: {
			taxIds: [
				{
					type: 'cl_tin',
					name: 'Chilean TIN',
					example: '12.345.678-K',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'China',
		countryCode: 'CN',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Christmas Island',
		countryCode: 'CX',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Cocos (Keeling) Islands',
		countryCode: 'CC',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Colombia',
		countryCode: 'CO',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Comoros',
		countryCode: 'KM',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Congo',
		countryCode: 'CG',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Congo, Democratic Republic of the',
		countryCode: 'CD',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Cook Islands',
		countryCode: 'CK',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Costa Rica',
		countryCode: 'CR',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: "Côte d'Ivoire",
		countryCode: 'CI',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Croatia',
		countryCode: 'HR',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'HR12345678912',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Cuba',
		countryCode: 'CU',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Curaçao',
		countryCode: 'CW',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Cyprus',
		countryCode: 'CY',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'CY12345678Z',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Czech Republic',
		countryCode: 'CZ',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'CZ1234567890',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Denmark',
		countryCode: 'DK',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'DK12345678',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Djibouti',
		countryCode: 'DJ',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Dominica',
		countryCode: 'DM',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Dominican Republic',
		countryCode: 'DO',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Ecuador',
		countryCode: 'EC',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Egypt',
		countryCode: 'EG',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'El Salvador',
		countryCode: 'SV',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Equatorial Guinea',
		countryCode: 'GQ',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Eritrea',
		countryCode: 'ER',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Estonia',
		countryCode: 'EE',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'EE123456789',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Eswatini',
		countryCode: 'SZ',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Ethiopia',
		countryCode: 'ET',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Falkland Islands (Malvinas)',
		countryCode: 'FK',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Faroe Islands',
		countryCode: 'FO',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Fiji',
		countryCode: 'FJ',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Finland',
		countryCode: 'FI',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'FI12345678',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'France',
		countryCode: 'FR',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'FRAB123456789',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'French Guiana',
		countryCode: 'GF',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'French Polynesia',
		countryCode: 'PF',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'French Southern Territories',
		countryCode: 'TF',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Gabon',
		countryCode: 'GA',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Gambia',
		countryCode: 'GM',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Georgia',
		countryCode: 'GE',
		tax: {
			taxIds: [
				{
					type: 'ge_vat',
					name: 'Georgian VAT',
					example: '123456789',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Germany',
		countryCode: 'DE',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'DE123456789',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Ghana',
		countryCode: 'GH',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Gibraltar',
		countryCode: 'GI',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Greece',
		countryCode: 'GR',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'EL123456789',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Greenland',
		countryCode: 'GL',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Grenada',
		countryCode: 'GD',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Guadeloupe',
		countryCode: 'GP',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Guam',
		countryCode: 'GU',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Guatemala',
		countryCode: 'GT',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Guernsey',
		countryCode: 'GG',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Guinea',
		countryCode: 'GN',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Guinea-Bissau',
		countryCode: 'GW',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Guyana',
		countryCode: 'GY',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Haiti',
		countryCode: 'HT',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Heard Island and McDonald Islands',
		countryCode: 'HM',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Holy See',
		countryCode: 'VA',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Honduras',
		countryCode: 'HN',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Hong Kong',
		countryCode: 'HK',
		tax: {
			taxIds: [
				{
					type: 'hk_br',
					name: 'Hong Kong BR number',
					example: '12345678',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Hungary',
		countryCode: 'HU',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'HU12345678912',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Iceland',
		countryCode: 'IS',
		tax: {
			taxIds: [
				{
					type: 'is_vat',
					name: 'Icelandic VAT',
					example: '123456',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'India',
		countryCode: 'IN',
		tax: {
			taxIds: [
				{
					type: 'in_gst',
					name: 'Indian GST number',
					example: '12ABCDE3456FGZH',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Indonesia',
		countryCode: 'ID',
		tax: {
			taxIds: [
				{
					type: 'id_npwp',
					name: 'Indonesian NPWP number',
					example: '12.345.678.9-012.345',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Iran (Islamic Republic of)',
		countryCode: 'IR',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Iraq',
		countryCode: 'IQ',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Ireland',
		countryCode: 'IE',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'IE1234567AB',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Isle of Man',
		countryCode: 'IM',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Israel',
		countryCode: 'IL',
		tax: {
			taxIds: [
				{
					type: 'il_vat',
					name: 'Israel VAT',
					example: '000012345',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Italy',
		countryCode: 'IT',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'IT12345678912',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Jamaica',
		countryCode: 'JM',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Japan',
		countryCode: 'JP',
		tax: {
			taxIds: [
				{
					type: 'jp_cn',
					name: 'Japanese Corporate Number (*Hōjin Bangō*)',
					example: '1234567891234',
				},
				{
					type: 'jp_rn',
					name: "Japanese Registered Foreign Businesses' Registration Number (*Tōroku Kokugai Jigyōsha no Tōroku Bangō*)",
					example: '12345',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Jersey',
		countryCode: 'JE',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Jordan',
		countryCode: 'JO',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Kazakhstan',
		countryCode: 'KZ',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Kenya',
		countryCode: 'KE',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Kiribati',
		countryCode: 'KI',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: "Korea (Democratic People's Republic of)",
		countryCode: 'KP',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'South Korea',
		countryCode: 'KR',
		tax: {
			taxIds: [
				{
					type: 'kr_brn',
					name: 'Korean BRN',
					example: '123-45-67890',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Kuwait',
		countryCode: 'KW',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Kyrgyzstan',
		countryCode: 'KG',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: "Lao People's Democratic Republic",
		countryCode: 'LA',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Latvia',
		countryCode: 'LV',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'LV12345678912',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Lebanon',
		countryCode: 'LB',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Lesotho',
		countryCode: 'LS',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Liberia',
		countryCode: 'LR',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Libya',
		countryCode: 'LY',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Liechtenstein',
		countryCode: 'LI',
		tax: {
			taxIds: [
				{
					type: 'li_uid',
					name: 'Liechtensteinian UID number',
					example: 'CHE123456789',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Lithuania',
		countryCode: 'LT',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'LT123456789123',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Luxembourg',
		countryCode: 'LU',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'LU12345678',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Macao',
		countryCode: 'MO',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Madagascar',
		countryCode: 'MG',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Malawi',
		countryCode: 'MW',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Malaysia',
		countryCode: 'MY',
		tax: {
			taxIds: [
				{
					type: 'my_frp',
					name: 'Malaysian FRP number',
					example: '12345678',
				},
				{
					type: 'my_itn',
					name: 'Malaysian ITN\tC',
					example: '1234567890',
				},
				{
					type: 'my_sst',
					name: 'Malaysian SST number',
					example: 'A12-3456-78912345',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Maldives',
		countryCode: 'MV',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Mali',
		countryCode: 'ML',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Malta',
		countryCode: 'MT',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'MT12345678',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Marshall Islands',
		countryCode: 'MH',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Martinique',
		countryCode: 'MQ',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Mauritania',
		countryCode: 'MR',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Mauritius',
		countryCode: 'MU',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Mayotte',
		countryCode: 'YT',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Mexico',
		countryCode: 'MX',
		tax: {
			taxIds: [
				{
					type: 'mx_rfc',
					name: 'Mexican RFC number',
					example: 'ABC010203AB9',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Micronesia (Federated States of)',
		countryCode: 'FM',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Moldova, Republic of',
		countryCode: 'MD',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Monaco',
		countryCode: 'MC',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Mongolia',
		countryCode: 'MN',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Montenegro',
		countryCode: 'ME',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Montserrat',
		countryCode: 'MS',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Morocco',
		countryCode: 'MA',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Mozambique',
		countryCode: 'MZ',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Myanmar',
		countryCode: 'MM',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Namibia',
		countryCode: 'NA',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Nauru',
		countryCode: 'NR',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Nepal',
		countryCode: 'NP',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Netherlands',
		countryCode: 'NL',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'NL123456789B12',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'New Caledonia',
		countryCode: 'NC',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'New Zealand',
		countryCode: 'NZ',
		tax: {
			taxIds: [
				{
					type: 'nz_gst',
					name: 'New Zealand GST number',
					example: '123456789',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Nicaragua',
		countryCode: 'NI',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Niger',
		countryCode: 'NE',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Nigeria',
		countryCode: 'NG',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Niue',
		countryCode: 'NU',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Norfolk Island',
		countryCode: 'NF',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'North Macedonia',
		countryCode: 'MK',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Northern Mariana Islands',
		countryCode: 'MP',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Norway',
		countryCode: 'NO',
		tax: {
			taxIds: [
				{
					type: 'no_vat',
					name: 'Norwegian VAT number',
					example: '123456789MVA',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Oman',
		countryCode: 'OM',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Pakistan',
		countryCode: 'PK',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Palau',
		countryCode: 'PW',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Palestine, State of',
		countryCode: 'PS',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Panama',
		countryCode: 'PA',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Papua New Guinea',
		countryCode: 'PG',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Paraguay',
		countryCode: 'PY',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Peru',
		countryCode: 'PE',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Philippines',
		countryCode: 'PH',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Pitcairn',
		countryCode: 'PN',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Poland',
		countryCode: 'PL',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'PL1234567890',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Portugal',
		countryCode: 'PT',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'PT123456789',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Puerto Rico',
		countryCode: 'PR',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Qatar',
		countryCode: 'QA',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Réunion',
		countryCode: 'RE',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Romania',
		countryCode: 'RO',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'RO1234567891',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Russia',
		countryCode: 'RU',
		tax: {
			taxIds: [
				{
					type: 'ru_inn',
					name: 'Russian INN',
					example: '1234567891',
				},
				{
					type: 'ru_kpp',
					name: 'Russian KPP',
					example: '123456789',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Rwanda',
		countryCode: 'RW',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Saint Barthélemy',
		countryCode: 'BL',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Saint Helena, Ascension and Tristan da Cunha',
		countryCode: 'SH',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Saint Kitts and Nevis',
		countryCode: 'KN',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Saint Lucia',
		countryCode: 'LC',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Saint Martin (French part)',
		countryCode: 'MF',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Saint Pierre and Miquelon',
		countryCode: 'PM',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Saint Vincent and the Grenadines',
		countryCode: 'VC',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Samoa',
		countryCode: 'WS',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'San Marino',
		countryCode: 'SM',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Sao Tome and Principe',
		countryCode: 'ST',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Saudi Arabia',
		countryCode: 'SA',
		tax: {
			taxIds: [
				{
					type: 'sa_vat',
					name: 'Saudi Arabia VAT',
					example: '123456789012345',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Senegal',
		countryCode: 'SN',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Serbia',
		countryCode: 'RS',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Seychelles',
		countryCode: 'SC',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Sierra Leone',
		countryCode: 'SL',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Singapore',
		countryCode: 'SG',
		tax: {
			taxIds: [
				{
					type: 'sg_gst',
					name: 'Singaporean GST',
					example: 'M12345678X',
				},
				{
					type: 'sg_uen',
					name: 'Singaporean UEN',
					example: '123456789F',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Sint Maarten (Dutch part)',
		countryCode: 'SX',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Slovakia',
		countryCode: 'SK',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'SK1234567891',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Slovenia',
		countryCode: 'SI',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'SI12345678',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Solomon Islands',
		countryCode: 'SB',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Somalia',
		countryCode: 'SO',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'South Africa',
		countryCode: 'ZA',
		tax: {
			taxIds: [
				{
					type: 'za_vat',
					name: 'South African VAT number',
					example: '4123456789',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'South Georgia and the South Sandwich Islands',
		countryCode: 'GS',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'South Sudan',
		countryCode: 'SS',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Spain',
		countryCode: 'ES',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'ESA1234567Z',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Sri Lanka',
		countryCode: 'LK',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Sudan',
		countryCode: 'SD',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Suriname',
		countryCode: 'SR',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Svalbard and Jan Mayen',
		countryCode: 'SJ',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Sweden',
		countryCode: 'SE',
		tax: {
			taxIds: [
				{
					type: 'eu_vat',
					name: 'European VAT number',
					example: 'SE123456789123',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: true,
			},
		},
	},
	{
		countryName: 'Switzerland',
		countryCode: 'CH',
		tax: {
			taxIds: [
				{
					type: 'ch_vat',
					name: 'Switzerland VAT number',
					example: 'CHE-123.456.789 MWST',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Syrian Arab Republic',
		countryCode: 'SY',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Taiwan',
		countryCode: 'TW',
		tax: {
			taxIds: [
				{
					type: 'tw_vat',
					name: 'Taiwanese VAT',
					example: '12345678',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Tajikistan',
		countryCode: 'TJ',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Tanzania, United Republic of',
		countryCode: 'TZ',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Thailand',
		countryCode: 'TH',
		tax: {
			taxIds: [
				{
					type: 'th_vat',
					name: 'Thai VAT',
					example: '1234567891234',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Timor-Leste',
		countryCode: 'TL',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Togo',
		countryCode: 'TG',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Tokelau',
		countryCode: 'TK',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Tonga',
		countryCode: 'TO',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Trinidad and Tobago',
		countryCode: 'TT',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Tunisia',
		countryCode: 'TN',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Turkey',
		countryCode: 'TR',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Turkmenistan',
		countryCode: 'TM',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Turks and Caicos Islands',
		countryCode: 'TC',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Tuvalu',
		countryCode: 'TV',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Uganda',
		countryCode: 'UG',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Ukraine',
		countryCode: 'UA',
		tax: {
			taxIds: [
				{
					type: 'ua_vat',
					name: 'Ukrainian VAT',
					example: '123456789',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'United Arab Emirates',
		countryCode: 'AE',
		tax: {
			taxIds: [
				{
					type: 'ae_trn',
					name: 'United Arab Emirates TRN',
					example: '123456789012345',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'United Kingdom',
		countryCode: 'GB',
		tax: {
			taxIds: [
				{
					type: 'gb_vat',
					name: 'United Kingdom VAT number',
					example: 'GB123456789',
				},
				{
					type: 'eu_vat',
					name: 'Northern Ireland VAT number',
					example: 'XI123456789',
				},
			],
			euVATScheme: {
				forGoods: true,
				forServices: false,
			},
		},
	},
	{
		countryName: 'United States',
		countryCode: 'US',
		tax: {
			taxIds: [
				{
					type: 'us_ein',
					name: 'United States EIN',
					example: '12-3456789',
				},
			],
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'United States Minor Outlying Islands',
		countryCode: 'UM',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Uruguay',
		countryCode: 'UY',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Uzbekistan',
		countryCode: 'UZ',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Vanuatu',
		countryCode: 'VU',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Venezuela (Bolivarian Republic of)',
		countryCode: 'VE',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Viet Nam',
		countryCode: 'VN',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Virgin Islands (British)',
		countryCode: 'VG',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Virgin Islands (U.S.)',
		countryCode: 'VI',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Wallis and Futuna',
		countryCode: 'WF',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Western Sahara',
		countryCode: 'EH',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Yemen',
		countryCode: 'YE',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Zambia',
		countryCode: 'ZM',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
	{
		countryName: 'Zimbabwe',
		countryCode: 'ZW',
		tax: {
			euVATScheme: {
				forGoods: false,
				forServices: false,
			},
		},
	},
];
